export var TASK_EVENT_TYPE;
(function (TASK_EVENT_TYPE) {
    TASK_EVENT_TYPE["POST_EXAM_SCHEDULE"] = "AEX";
    TASK_EVENT_TYPE["POST_CONSULTATION_SCHEDULE"] = "ACO";
    TASK_EVENT_TYPE["POST_SURGERY_SCHEDULE"] = "ACI";
    TASK_EVENT_TYPE["GOING_TO_PROMPT_SERVICE"] = "IPA";
    TASK_EVENT_TYPE["POST_CONSULTATION_SCHEDULE_EXEC"] = "EAC";
    TASK_EVENT_TYPE["POST_EXAM_SCHEDULE_EXEC"] = "EAE";
    TASK_EVENT_TYPE["POST_SURGERY_SCHEDULE_EXEC"] = "EAG";
    TASK_EVENT_TYPE["POST_PATIENT_DISCHARGE"] = "EAP";
})(TASK_EVENT_TYPE || (TASK_EVENT_TYPE = {}));
//# sourceMappingURL=task-event-type.js.map